// Mega Menu JavaScript

(function() {
  'use strict';

  class MegaMenu {
    constructor() {
      this.menus = document.querySelectorAll('.mega-menu');
      if (!this.menus.length) return;
      
      this.init();
    }

    init() {
      this.menus.forEach(menu => {
        const trigger = menu.querySelector('.mega-menu__trigger');
        const dropdown = menu.querySelector('.mega-menu__dropdown');
        
        if (!trigger || !dropdown) return;

        // Desktop: hover behavior
        let closeTimeout;
        
        menu.addEventListener('mouseenter', () => {
          clearTimeout(closeTimeout);
          this.closeAllMenus();
          menu.classList.add('is-active');
        });

        menu.addEventListener('mouseleave', () => {
          closeTimeout = setTimeout(() => {
            menu.classList.remove('is-active');
          }, 150);
        });

        // Mobile/Touch: click behavior
        trigger.addEventListener('click', (e) => {
          if (window.innerWidth < 768) {
            e.preventDefault();
            menu.classList.toggle('is-active');
          }
        });

        // Keyboard accessibility
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            menu.classList.toggle('is-active');
          }
          if (e.key === 'Escape') {
            menu.classList.remove('is-active');
            trigger.focus();
          }
        });
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.mega-menu')) {
          this.closeAllMenus();
        }
      });

      // Close on escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllMenus();
        }
      });
    }

    closeAllMenus() {
      this.menus.forEach(menu => menu.classList.remove('is-active'));
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
  });
})();
